<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Calculadora de risco cardiovascular (Framingham)"
    >
        <rkm-form
            v-if="!!model"
            ref="RkmForm"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :value="data.form.paciente && data.form.paciente.sexoDescricao"
                        disabled
                        label="Sexo"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :value="data.form.paciente && data.form.paciente.idadeFormatada"
                        disabled
                        label="Idade"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.colesterolTotal"
                        label="Colesterol total"
                        v-mask="'###'"
                        v-model="model.colesterolTotal"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                mg/dL
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.colesterolHdl"
                        label="Colesterol HDL"
                        v-mask="'###'"
                        v-model="model.colesterolHdl"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                mg/dL
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.pressaoArterial"
                        label="Pressão arterial"
                        placeholder="000/000"
                        v-mask="'###/###'"
                        v-model="model.pressaoArterial"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                mmHg
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Toma remédio para hipertensão?"
                        v-model="model.tomaRemedioHipertensao"
                    >
                    <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        label="Tabagista?"
                        v-model="model.tabagista"
                    >
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Diabetes?"
                        v-model="model.diabetico"
                    >
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-alert
                v-if="resultadoRiscoCardiovascularFramingham"
                :color="alertColorResultadoRiscoCardiovascularFramingham"
            >
                <strong>Pontuação:</strong> {{ resultadoRiscoCardiovascularFramingham.pontuacao }},
                <strong>Risco (%) em 10 anos:</strong> {{ resultadoRiscoCardiovascularFramingham.porcentagem }},
                <strong>Classificação (Risco em 10 anos):</strong> {{ resultadoRiscoCardiovascularFramingham.classificacao }}
            </rkm-alert>
        </rkm-form>

        <rkm-area
            title="Histórico"
            type="fieldset"
        >
            <rkm-table
                :fields="fields"
                :items="data.form.historicoSoap.riscoCardiovascularFramingham"
                :tbody-tr-class="rowClass"
            >
                <!-- <template v-slot:cell(actions)="{item}">
                    <rkm-button
                        @click="print(item)"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>
                </template> -->
            </rkm-table>
        </rkm-area>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="clear"
                color="info"
            >
                Limpar formulário
            </rkm-button>

            <rkm-button
                @click="store"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'

// Mixins.
import { error, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                colesterolTotal: {
                    required: true,
                    min_value: 0,
                    max_value: 999,
                },
                colesterolHdl: {
                    required: true,
                    min_value: 0,
                    max_value: 999,
                },
                pressaoArterial: {
                    required: true,
                    min_max_without_mask: [6],
                    pressao_arterial: true,
                },
            }
        },
        alertColorResultadoRiscoCardiovascularFramingham() {
            if (this.resultadoRiscoCardiovascularFramingham.porcentagem < 10) {
                return 'success'
            }
            else if (this.resultadoRiscoCardiovascularFramingham.porcentagem < 20) {
                return 'warning'
            }
            else {
                return 'danger'
            }
        },
    },
    data: () => ({
        enums: {sexo},
        fields: [
            {key: 'dataHoraAtendimento', label: 'Data/Hora'},
            {key: 'usuarioNome', label: 'Profissional'},
            {key: 'pontuacao', label: 'Pontuação'},
            {key: 'porcentagem', label: 'Risco (%) em 10 anos'},
            {key: 'classificacao', label: 'Classificação (Risco em 10 anos)'},
        ],
        item: null,
        model: null,
        resultadoRiscoCardiovascularFramingham: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item = null) {
            this.item = item

            this.model = {
                colesterolTotal: item.riscoCardiovascularFramingham.colesterolTotal,
                colesterolHdl: item.riscoCardiovascularFramingham.colesterolHdl,
                pressaoArterial: item.objetivo.sinalVital.pressaoArterial,
                tomaRemedioHipertensao: item.riscoCardiovascularFramingham.tomaRemedioHipertensao,
                tabagista: item.riscoCardiovascularFramingham.tabagista,
                diabetico: item.riscoCardiovascularFramingham.diabetico,
            }

            this.$refs.RkmModal.show()
        },
        store() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.item.riscoCardiovascularFramingham = {
                        colesterolTotal: this.model.colesterolTotal,
                        colesterolHdl: this.model.colesterolHdl,
                        tomaRemedioHipertensao: this.model.tomaRemedioHipertensao,
                        tabagista: this.model.tabagista,
                        diabetico: this.model.diabetico,
                        pontuacao: this.resultadoRiscoCardiovascularFramingham?.pontuacao,
                    }

                    this.item.objetivo.sinalVital.pressaoArterial = this.model.pressaoArterial

                    this.$refs.RkmModal.hide()
                })
        },
        clear() {
            this.model = null

            this.item.riscoCardiovascularFramingham = {
                colesterolTotal: null,
                colesterolHdl: null,
                tomaRemedioHipertensao: false,
                tabagista: false,
                diabetico: false,
            }

            this.$refs.RkmModal.hide()
        },
        rowClass(item, type) {
            if (type === 'row' && item) {
                if (item.porcentagem < 10) {
                    return 'table-success'
                }
                else if (item.porcentagem < 20) {
                    return 'table-warning'
                }
                else {
                    return 'table-danger'
                }
            }
        },
        getResultaRiscoCardiovascularFramingham(sexoId, idade, colesterolTotal, colesterolHdl, pressaoArterial, tomaRemedioHipertensao, tabagista, diabetico) {
            let pontuacao = 0

            pontuacao += this.getPontuacaoIdadeRiscoCardiovascularFramingham(sexoId, idade)
            pontuacao += this.getPontuacaoColesterolTotalRiscoCardiovascularFramingham(sexoId, idade, Number(colesterolTotal))
            pontuacao += this.getPontuacaoColesterolHdlRiscoCardiovascularFramingham(Number(colesterolHdl))
            pontuacao += this.getPontuacaoPressaoArterialRiscoCardiovascularFramingham(sexoId, pressaoArterial, tomaRemedioHipertensao)
            pontuacao += this.getPontuacaoTabagismoRiscoCardiovascularFramingham(sexoId, idade, tabagista)
            pontuacao += this.getPontuacaoDiabetesRiscoCardiovascularFramingham(sexoId, diabetico)

            const porcentagem = this.getPorcentagemRiscoCardiovascularFramingham(sexoId, pontuacao)

            let classificacao = null

            if (porcentagem < 10) {
                classificacao = 'Baixo risco'
            } else if (porcentagem < 20) {
                classificacao = 'Risco intermediário'
            } else {
                classificacao = 'Alto risco'
            }

            return {
                pontuacao,
                classificacao,
                porcentagem,
            }
        },
        getPontuacaoIdadeRiscoCardiovascularFramingham(sexoId, idade) {
            if (sexoId === this.enums.sexo.MASCULINO) {
                if (idade >= 20 && idade <= 34) return -9
                else if (idade >= 35 && idade <= 39) return -4
                else if (idade >= 40 && idade <= 44) return 0
                else if (idade >= 45 && idade <= 49) return 3
                else if (idade >= 50 && idade <= 54) return 6
                else if (idade >= 55 && idade <= 59) return 8
                else if (idade >= 60 && idade <= 64) return 10
                else if (idade >= 65 && idade <= 69) return 11
                else if (idade >= 70 && idade <= 74) return 12
                else if (idade >= 75) return 13
            } else {
                if (idade >= 20 && idade <= 34) return -7
                else if (idade >= 35 && idade <= 39) return -3
                else if (idade >= 40 && idade <= 44) return 0
                else if (idade >= 45 && idade <= 49) return 3
                else if (idade >= 50 && idade <= 54) return 6
                else if (idade >= 55 && idade <= 59) return 8
                else if (idade >= 60 && idade <= 64) return 10
                else if (idade >= 65 && idade <= 69) return 12
                else if (idade >= 70 && idade <= 74) return 14
                else if (idade >= 75) return 16
            }

            return 0
        },
        getPontuacaoColesterolTotalRiscoCardiovascularFramingham(sexoId, idade, colesterolTotal) {
            if (colesterolTotal < 160) return 0

            if (sexoId === this.enums.sexo.MASCULINO) {
                if (idade >= 20 && idade <= 39) {
                    if (colesterolTotal <= 199) return 4
                    else if (colesterolTotal <= 239) return 7
                    else if (colesterolTotal <= 279) return 9
                    return 11
                } else if (idade >= 40 && idade <= 49) {
                    if (colesterolTotal <= 199) return 3
                    else if (colesterolTotal <= 239) return 5
                    else if (colesterolTotal <= 279) return 6
                    return 8
                } else if (idade >= 50 && idade <= 59) {
                    if (colesterolTotal <= 199) return 2
                    else if (colesterolTotal <= 239) return 3
                    else if (colesterolTotal <= 279) return 4
                    return 5
                } else if (idade >= 60 && idade <= 69) {
                    if (colesterolTotal <= 199) return 1
                    else if (colesterolTotal <= 239) return 1
                    else if (colesterolTotal <= 279) return 2
                    return 3
                } else {
                    if (colesterolTotal <= 199) return 0
                    else if (colesterolTotal <= 239) return 1
                    else if (colesterolTotal <= 279) return 1
                    return 1
                }
            } else {
                if (idade >= 20 && idade <= 39) {
                    if (colesterolTotal <= 199) return 4
                    else if (colesterolTotal <= 239) return 8
                    else if (colesterolTotal <= 279) return 11
                    return 13
                } else if (idade >= 40 && idade <= 49) {
                    if (colesterolTotal <= 199) return 3
                    else if (colesterolTotal <= 239) return 6
                    else if (colesterolTotal <= 279) return 8
                    return 10
                } else if (idade >= 50 && idade <= 59) {
                    if (colesterolTotal <= 199) return 2
                    else if (colesterolTotal <= 239) return 4
                    else if (colesterolTotal <= 279) return 5
                    return 7
                } else if (idade >= 60 && idade <= 69) {
                    if (colesterolTotal <= 199) return 1
                    else if (colesterolTotal <= 239) return 2
                    else if (colesterolTotal <= 279) return 3
                    return 4
                } else {
                    if (colesterolTotal <= 199) return 1
                    else if (colesterolTotal <= 239) return 1
                    else if (colesterolTotal <= 279) return 2
                    return 2
                }
            }
        },
        getPontuacaoColesterolHdlRiscoCardiovascularFramingham(colesterolHdl) {
            if (colesterolHdl >= 60) return -1
            else if (colesterolHdl >= 50) return 0
            else if (colesterolHdl >= 40) return 1

            return 2
        },
        getPontuacaoPressaoArterialRiscoCardiovascularFramingham(sexoId, pressaoArterial, tomaRemedioHipertensao) {
            if (!pressaoArterial) return 0

            const partes = String(pressaoArterial).split('/')
            const sistolica = parseInt(partes[0]) || 0

            if (sexoId === this.enums.sexo.MASCULINO) {
                if (tomaRemedioHipertensao) {
                    if (sistolica < 120) return 0
                    else if (sistolica <= 129) return 1
                    else if (sistolica <= 139) return 2
                    else if (sistolica <= 159) return 2
                    return 3
                } else {
                    if (sistolica < 120) return 0
                    else if (sistolica <= 129) return 0
                    else if (sistolica <= 139) return 1
                    else if (sistolica <= 159) return 1
                    return 2
                }
            } else {
                if (tomaRemedioHipertensao) {
                    if (sistolica < 120) return 0
                    else if (sistolica <= 129) return 3
                    else if (sistolica <= 139) return 4
                    else if (sistolica <= 159) return 5
                    return 6
                } else {
                    if (sistolica < 120) return 0
                    else if (sistolica <= 129) return 1
                    else if (sistolica <= 139) return 2
                    else if (sistolica <= 159) return 3
                    return 4
                }
            }
        },
        getPontuacaoTabagismoRiscoCardiovascularFramingham(sexoId, idade, tabagista) {
            if (!tabagista) return 0

            if (sexoId === this.enums.sexo.MASCULINO) {
                if (idade >= 20 && idade <= 39) return 8
                else if (idade >= 40 && idade <= 49) return 5
                else if (idade >= 50 && idade <= 59) return 3
                else if (idade >= 60 && idade <= 69) return 1
                return 1
            } else {
                if (idade >= 20 && idade <= 39) return 9
                else if (idade >= 40 && idade <= 49) return 7
                else if (idade >= 50 && idade <= 59) return 4
                else if (idade >= 60 && idade <= 69) return 2
                return 1
            }
        },
        getPontuacaoDiabetesRiscoCardiovascularFramingham(sexoId, diabetico) {
            if (!diabetico) return 0

            return sexoId === this.enums.sexo.MASCULINO ? 2 : 4
        },
        getPorcentagemRiscoCardiovascularFramingham(sexoId, pontuacao) {
            if (sexoId === this.enums.sexo.MASCULINO) {
                if (pontuacao <= 4) return 1
                else if (pontuacao <= 6) return 2
                else if (pontuacao === 7) return 3
                else if (pontuacao === 8) return 4
                else if (pontuacao === 9) return 5
                else if (pontuacao === 10) return 6
                else if (pontuacao === 11) return 8
                else if (pontuacao === 12) return 10
                else if (pontuacao === 13) return 12
                else if (pontuacao === 14) return 16
                else if (pontuacao === 15) return 20
                else if (pontuacao === 16) return 25
                return 30
            } else {
                if (pontuacao <= 12) return 1
                else if (pontuacao <= 14) return 2
                else if (pontuacao === 15) return 3
                else if (pontuacao === 16) return 4
                else if (pontuacao === 17) return 5
                else if (pontuacao === 18) return 6
                else if (pontuacao === 19) return 8
                else if (pontuacao === 20) return 11
                else if (pontuacao === 21) return 14
                else if (pontuacao === 22) return 17
                else if (pontuacao === 23) return 22
                else if (pontuacao === 24) return 27
                return 30
            }
        },
    },
    mixins: [error, object],
    props: {
        data: {type: Object, required: true},
    },
    watch: {
        'model': {
            deep: true,
            handler(value) {
                if (value && value.colesterolTotal && value.colesterolHdl && value.pressaoArterial) {
                    this.resultadoRiscoCardiovascularFramingham = this.getResultaRiscoCardiovascularFramingham(
                        this.data.form.paciente.sexoId,
                        this.data.form.paciente.idadeAnos,
                        value.colesterolTotal,
                        value.colesterolHdl,
                        value.pressaoArterial,
                        value.tomaRemedioHipertensao,
                        value.tabagista,
                        value.diabetico,
                    )
                } else {
                    this.resultadoRiscoCardiovascularFramingham = null
                }
            },
        },
    },
}
</script>